const ACTIONS = {
    ATTRIBUTES_FILTERS_REQUEST_SUCCESS: "ATTRIBUTES_FILTERS_REQUEST_SUCCESS",
    ATTRIBUTES_FILTERS_SET_ACTIVE_FILTER: "ATTRIBUTES_FILTERS_SET_ACTIVE_FILTER",
    ATTRIBUTES_FILTERS_OPEN_NEW_FILTER: "ATTRIBUTES_FILTERS_OPEN_NEW_FILTER",
    ATTRIBUTES_FILTERS_OPEN_FILTER_EDIT: "ATTRIBUTES_FILTERS_OPEN_FILTER_EDIT",
    ATTRIBUTES_FILTERS_OPEN_FILTER_PARAMS: "ATTRIBUTES_FILTERS_OPEN_FILTER_PARAMS",
    ATTRIBUTES_FILTERS_DELETE_FILTER: "ATTRIBUTES_FILTERS_DELETE_FILTER",
    ATTRIBUTES_FILTERS_CLOSE_FILTER_FORM: "ATTRIBUTES_FILTERS_CLOSE_FILTER_FORM",
    ATTRIBUTES_FILTERS_SET_ATTRIBUTES: "ATTRIBUTES_FILTERS_SET_ATTRIBUTES",
    ATTRIBUTES_FILTERS_SET_FILTERS_LOADING: "ATTRIBUTES_FILTERS_SET_FILTERS_LOADING",
};

function getActiveFilter(filters, filterId) {
    let currentActiveFilter;

    if (filters && filterId) {
        filters.forEach(filter => {
            if (+filter.filterId === +filterId) {
                currentActiveFilter = filter;
                return;
            }
            // check active filters in subfilters
            if (filter.filters) {
                filter.filters.forEach(subFilter => {
                    if (+subFilter.filterId === +filterId) {
                        currentActiveFilter = subFilter;
                    }
                });
            }
        });
    }

    return currentActiveFilter;
}

/* initial state */
const initialState = {};

/* reducer */
export default (state = initialState, action) => {
    const prevData = state[action.storeKey] || {};
    switch (action.type) {
        case ACTIONS.ATTRIBUTES_FILTERS_REQUEST_SUCCESS: {
            const {activeFilter} = prevData;
            let currentActiveFilter;
            if (activeFilter) {
                currentActiveFilter = getActiveFilter(action.filters, activeFilter.filterId)
            }

            // update currentActiveFilter data, for example filter was edited => sync its name and etc
            return {
                ...state,
                [action.storeKey]: {
                    ...prevData,
                    filters: action.filters,
                    activeFilter: currentActiveFilter || activeFilter,
                },
            };
        }
        case ACTIONS.ATTRIBUTES_FILTERS_SET_ACTIVE_FILTER: {
            const { filters } = prevData;

            const prevActiveFilter = prevData.activeFilter;

            if (prevActiveFilter && +prevActiveFilter.filterId === +action.activeFilter) {
                return state;
            }

            const currentActiveFilter = getActiveFilter(filters, action.activeFilter);
            // on filter select => set as set isFilterParams and reset isNewFilter to false
            return {
                ...state,
                [action.storeKey]: {
                    ...prevData,
                    activeFilter: currentActiveFilter,
                    isFilterParams: true,
                    isNewFilter: false,
                    isEditFilter: false,
                },
            };
        }
        case ACTIONS.ATTRIBUTES_FILTERS_OPEN_NEW_FILTER: {
            return {
                ...state,
                [action.storeKey]: {
                    ...prevData,
                    showFilterForm: true,
                    isNewFilter: true,
                    isFilterParams: false,
                    isEditFilter: false,
                },
            };
        }
        case ACTIONS.ATTRIBUTES_FILTERS_OPEN_FILTER_EDIT: {
            return {
                ...state,
                [action.storeKey]: {
                    ...prevData,
                    showFilterForm: true,
                    isNewFilter: false,
                    isFilterParams: false,
                    isEditFilter: true,
                },
            };
        }
        case ACTIONS.ATTRIBUTES_FILTERS_OPEN_FILTER_PARAMS: {
            return {
                ...state,
                [action.storeKey]: {
                    ...prevData,
                    showFilterForm: true,
                    isFilterParams: true,
                    isNewFilter: false,
                    isEditFilter: false,
                },
            };
        }
        case ACTIONS.ATTRIBUTES_FILTERS_SET_ATTRIBUTES: {
            return {
                ...state,
                [action.storeKey]: { ...prevData, attributes: action.attributes },
            };
        }
        case ACTIONS.ATTRIBUTES_FILTERS_CLOSE_FILTER_FORM: {
            return {
                ...state,
                [action.storeKey]: { ...prevData, showFilterForm: false },
            };
        }
        case ACTIONS.ATTRIBUTES_FILTERS_SET_FILTERS_LOADING: {
            return {
                ...state,
                [action.storeKey]: { ...prevData, isFiltersLoading: action.isLoading },
            };
        }
        default: {
            return state;
        }
    }
};

/* action creators */
export const setFilters = (filters, storeKey) => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_REQUEST_SUCCESS,
    filters,
    storeKey,
});

export const setActiveFilter = (activeFilter, storeKey) => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_SET_ACTIVE_FILTER,
    activeFilter,
    storeKey,
});

export const openNewFilter = storeKey => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_OPEN_NEW_FILTER,
    storeKey,
});

export const openFilterParams = storeKey => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_OPEN_FILTER_PARAMS,
    storeKey,
});

export const openFilterEdit = storeKey => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_OPEN_FILTER_EDIT,
    storeKey,
});

export const closeFilterForm = storeKey => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_CLOSE_FILTER_FORM,
    storeKey,
});

export const setAttributes = (attributes, storeKey) => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_SET_ATTRIBUTES,
    attributes,
    storeKey,
});

export const setFiltersLoading = (isLoading, storeKey) => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_SET_FILTERS_LOADING,
    isLoading,
    storeKey,
});

export const onFilterDelete = storeKey => ({
    type: ACTIONS.ATTRIBUTES_FILTERS_DELETE_FILTER,
    storeKey,
});
